/** @format */
import apm from '../../helpers/elastic-apm-rum';
import { flattenObject } from '../../helpers/object';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
type Labels = Record<string, any>;

const formatLabels = (labels: Labels) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    return flattenObject(labels, (val: any) => `${val}`);
};

const addLabels = (labels: Labels) =>
    // eslint-disable-next-line no-console -- Legacy code: do not use as an example.
    apm ? apm?.addLabels(formatLabels(labels)) : console.log(labels);

const logError = (error: Error | string) =>
    apm ? apm?.captureError(error) : console.error(error);

export default {
    error: logError,
    addLabels,
};
